import { createContext } from "react";

export const SELECTED_INVOICES = createContext()
export const SELECTED_CUSTOMER = createContext()
export const SOCKETS = createContext()
export const IS_EDIT_OPEN = createContext()
export const CUSTOMERINFO = createContext()